import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/thrombophilia";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	thrombophilia: {
		id: "form.thrombophilia",
		defaultMessage: "Thrombophilia"
	},
	comment: {
		id: "form.thrombophilia.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.comment }] }]
};

export const node: LeafNode = {
	id: "thrombophilia",
	value: {
		title: messages.thrombophilia,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
